<script>
import HonorCalculationTable from "./HonorCalculationTable.vue";

export default {
  components: {
    HonorCalculationTable,
  },
  data() {
    return {
      columns: [
        { width: "50px", label: "No", name: "id" },
        // { width: "200px", label: "Dahan Profesi", name: "dahan_profesi" },
        { width: "200px", label: "Kompetensi", name: "kompetensi" },
        { width: "200px", label: "Nama", name: "nama" },
        { width: "140px", label: "NIP", name: "nip" },
        { width: "160px", label: "NPWP", name: "npwp" },
        { width: "140px", label: "KTP", name: "nik" },
        { width: "160px", label: "Nomor Rekening", name: "nomor_rekening" },
        { width: "160px", label: "Nama Bank", name: "nama_bank" },
        { width: "140px", label: "Jumlah Paket", name: "jumlah_paket" },
        { width: "100px", label: "Level", name: "level" },
        { width: "120px", label: "Status", name: "status" },
        { width: "120px", label: "Pengisian BA", name: "pengisian_ba" },
        { width: "140px", label: "Honor per Paket", name: "honor_per_paket" },
        { width: "140px", label: "Realisasi Paket", name: "realisasi_paket" },
        { width: "140px", label: "Jumlah Honor", name: "jumlah_honor" },
        { width: "140px", label: "Bruto", name: "bruto" },
        { width: "140px", label: "DPP", name: "dpp" },
        { width: "160px", label: "PPh Ps.21", name: "pph" },
        { width: "180px", label: "Yang Dibayarkan", name: "dibayarkan" },
      ],
    };
  },
};
</script>

<template>
  <HonorCalculationTable
    api-url="verifikasi/perhitungan-honor/validator"
    add-form-config-api-url="verifikasi/konfig-honor/validator"
    konfig-honor-jenis="validator"
    :columns="columns"
    tab-title="Perhitungan Honor Validator"
    tab-subtitle="Kelola perhitungan honor validator berdasarkan kompetensi, paket, realisasi, dan berita acara."
    excel-file-name="perhitungan-honor-validator.xlsx"
    excel-sheet-name="Honor Validator"
    summary-main-label="Total Validator"
    :use-status-filter="true"
    :use-ba-filter="true"
    :require-ba-for-calculation="true"
    :use-validator-selects="true"
    :use-personal-data-columns="true"
  />
</template>
